import {atom} from "recoil";
import { WorkstationDetails } from '../ServiceStack/ServiceStack.dtos';
import { JsonServiceClient } from '@servicestack/client';


export const ServiceStackClient = atom({
    key: 'ServiceStackClient',
    default: new JsonServiceClient(process.env.REACT_APP_BASE_URL)
})

export const IsAuthorized = atom({
    key: 'IsAuthorized',
    default: false
})

export const WorkstationLandingLoading = atom({
    key: 'WorkstationLandingLoading',
    default: true
})

export const WorkstationStatusInterval = atom({
    key: 'WorkstationStatusInterval',
    default: null
})

export const WorkstationDetailsAtom = atom<WorkstationDetails>({
    key: 'UserName',
    default: undefined
})